import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconRemix = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M52.16 9.429c-.652.145-1.225.676-1.446 1.342-.14.42-.096 1.063.098 1.453.098.196.832.978 2.298 2.448l2.153 2.16-4 .001c-5 .001-5.955.06-7.423.454-1.836.494-3.893 1.582-5.632 2.979-.74.594-2.192 2.017-2.916 2.857-1.877 2.18-3.575 4.807-4.898 7.581-1.402 2.938-2.513 4.779-4.072 6.745-.743.937-2.406 2.641-3.139 3.216-1.556 1.224-3.17 2.007-4.783 2.322-.522.102-1.26.115-7.84.147l-7.264.034-.288.15c-.726.376-1.112 1.002-1.112 1.802s.386 1.426 1.112 1.803l.288.149h15.232l.822-.178c3.95-.853 7.412-3.337 10.635-7.63 1.637-2.18 2.544-3.731 4.213-7.2.782-1.626 2.178-3.86 3.38-5.408.685-.883 2.738-2.968 3.446-3.5 1.45-1.09 2.862-1.772 4.384-2.119.546-.124.82-.132 5.216-.156l4.64-.025-2.149 2.164c-2.46 2.477-2.459 2.476-2.459 3.348 0 .642.137.986.56 1.41.4.398.7.527 1.303.56.962.053.71.26 5.318-4.357 3.823-3.83 4.044-4.065 4.172-4.415a1.94 1.94 0 0 0-.172-1.742c-.085-.14-1.915-2.019-4.068-4.173-3.391-3.394-3.96-3.938-4.265-4.074a2.1 2.1 0 0 0-1.344-.148M3.534 16.902c-.445.076-.754.242-1.083.58-.393.406-.556.813-.559 1.398-.002.398.028.543.175.843.194.397.53.736.954.962l.275.147 7.136.037c7.001.035 7.148.039 7.771.174 1.902.414 3.383 1.056 4.856 2.107.665.475 1.786 1.552 2.35 2.26.243.304.555.631.694.728a2.08 2.08 0 0 0 1.81.249c.498-.159 1.075-.745 1.234-1.255.15-.482.117-1.056-.084-1.47-.331-.683-1.815-2.31-2.919-3.201-1.879-1.517-4.147-2.645-6.4-3.182-1.78-.424-1.426-.407-8.992-.422-3.856-.007-7.029.013-7.218.045M52.283 35.65c-1.293.212-2.047 1.692-1.45 2.846.12.23.76.912 2.282 2.432 1.165 1.161 2.117 2.135 2.117 2.163s-1.951.042-4.336.03c-4.172-.023-4.363-.029-5.06-.166-1.636-.321-3.499-1.113-4.81-2.045-.739-.525-1.841-1.575-2.436-2.32-.242-.304-.554-.631-.693-.728a2.14 2.14 0 0 0-1.838-.251c-.47.16-1.053.767-1.206 1.257-.15.482-.117 1.056.084 1.47.331.683 1.816 2.31 2.919 3.201 2.134 1.723 4.558 2.842 7.328 3.384.715.14.872.145 5.392.166 2.56.011 4.656.042 4.656.067 0 .024-.952.995-2.117 2.156-2.349 2.344-2.428 2.446-2.475 3.2-.082 1.294 1.024 2.273 2.336 2.067.202-.032.483-.126.624-.21.14-.084 2.06-1.962 4.265-4.173 3.794-3.805 4.016-4.04 4.144-4.39.074-.204.135-.513.135-.686s-.06-.482-.135-.686c-.128-.35-.35-.585-4.144-4.39-2.205-2.211-4.124-4.088-4.265-4.171-.226-.134-.359-.171-.896-.252-.07-.01-.26.003-.421.03" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconRemix.displayName = 'IconRemix';